import Button from "../button";
import {
  AppBar,
  List,
  IconButton,
  Popover,
  Toolbar,
  Box,
  Typography,
  Drawer,
  Avatar,
  Menu,
  MenuItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useMemo, useState, useEffect } from "react";
import DropdownWhiteIcon from "../icons/dropdown-white-icon";
import DropdownBlackIcon from "../icons/dropdown.black.icon";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SupplierIcon from "../../components/icons/sidebar/supplier-icon";
import CardIcon from "../../components/icons/sidebar/card-icon";
import walletIcon from "../../assets/icons/wallet.png";
import ProcessingIcon from "../../components/icons/sidebar/processing-icon";
import TransectionIcon from "../../components/icons/sidebar/transection-icon";
import { useTranslation } from "react-i18next";
import LanguageRounded from "@mui/icons-material/LanguageRounded";

import leftArrow from "../../assets/images/left-arrow.png";
import rightArrow from "../../assets/images/right-arrow.png";
import AdminRateInfo from "../../pages/adminRateInfo/adminRateInfo";
import {
  getCards,
  getWalletAmmount,
  getTotalCards,
} from "src/firebase/admin.js";

const drawerWidth = 280;
const supplierNavbar = [
  {
    link: "/supplier",
    title: "Cards Management",
    icon: <CardIcon />,
  },
  {
    link: "/supplier/rate-info",
    title: "Rate Info",
    icon: <TransectionIcon />,
  },
  {
    link: "/supplier/payment-info",
    title: "Payment Information",
    icon: <TransectionIcon />,
  },
  {
    link: "/supplier/verification-limit",
    title: "Verification Limit",
    icon: <TransectionIcon />,
  },
];

const processingTeamNavbar = [
  {
    link: "/processing-team",
    title: "User Cards Management",
    icon: <CardIcon />,
  },
  {
    link: "/processing-team/user-management",
    title: "User Management",
    icon: <SupplierIcon />,
  },
];

const adminNavbar = [
  {
    link: "/admin",
    title: "Supplier Management",
    icon: <SupplierIcon />,
  },
  {
    link: "/admin/processing-management",
    title: "Processing Management",
    icon: <ProcessingIcon />,
  },
  {
    link: "/admin/card-request",
    title: "Card Request",
    icon: <CardIcon />,
  },
  {
    link: "/admin/transaction-History",
    title: "Transaction History",
    icon: <TransectionIcon />,
  },
  {
    link: "/admin/rate-info",
    title: "Rate Info",
    icon: <TransectionIcon />,
  },
];
const SidebarItem = ({ item, dataIndex }: any) => {
  const { t } = useTranslation(["home"]);

  const activeRoute = useLocation();
  return (
    <Link to={item?.link}>
      <div
        className={`py-3 px-5 flex gap-x-2 cursor-pointer ${
          activeRoute.pathname === item.link ? "bg-blue" : "bg-transparent"
        }`}
      >
        {item.icon}
        <p className="text-white"> {t(item.title)}</p>
      </div>
    </Link>
  );
};

const SideBar = (props: any) => {
  const { t, i18n } = useTranslation(["home"]);
  const [anchorLanguage, setAnchorLanguage] = useState<null | HTMLElement>(
    null
  );
  const open = Boolean(anchorLanguage);

  useEffect(() => {
    setLanguage();
  }, []);
  const setLanguage = async () => {
    const lang = await localStorage.getItem("language");
    if (lang) {
      i18n.changeLanguage(lang);
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorLanguage(event.currentTarget);
  };
  const handleLanguageClose = () => {
    setAnchorLanguage(null);
  };

  const handleLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);
    handleLanguageClose();
  };

  const { window, admin, title, supplier } = props;
  const [mobileOpen, setMobileOpen] = useState<boolean>(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [showHideNavbar, setShowHideNavbar] = useState<boolean>(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [amount, setAmount] = useState(0);
  const navigate = useNavigate();
  const container =
    window !== undefined ? () => window().document.body : undefined;

  const profileData = useMemo(() => {
    let _data = localStorage.getItem("account");
    return JSON.parse(_data);
  }, []);

  useEffect(() => {
    if (supplier) {
      getCardList();
    }
  }, []);

  const getCardList = async () => {
    const accoount = JSON.parse(await localStorage.getItem("account"));
    let result: any = await getWalletAmmount(accoount.id);
    console.log("result", result);
    const sum = result.reduce((accumulator, object) => {
      return accumulator + parseFloat(object.amount) * parseFloat(object.rate);
    }, 0);
    setAmount(parseInt(sum));
  };

  const sideBarItems = useMemo(() => {
    return admin
      ? adminNavbar
      : supplier
      ? supplierNavbar
      : processingTeamNavbar;
  }, [admin, supplier]);

  const handleClickDropdown = (event: any) => {
    setAnchorEl(event.currentTarget);
    setIsDropdownOpen(true);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleCloseDropdown = () => {
    setAnchorEl(null);
    setIsDropdownOpen(false);
  };

  const drawer = (
    <div>
      <Toolbar>{/* <Logo height={56} className={"mt-4"} /> */}</Toolbar>
      <List>
        {sideBarItems.map((item, index) => (
          <SidebarItem item={item} dataIndex={index} />
        ))}
      </List>
    </div>
  );

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          width: {
            sm: `calc(100% -  ${showHideNavbar ? drawerWidth : "0"}px)`,
          },
          ml: { sm: `${showHideNavbar ? drawerWidth : "0"}px` },
        }}
      >
        <Toolbar className="flex justify-between bg-white ">
          <div className="flex gap-x-2 items-center">
            {!mobileOpen && (
              <>
                {showHideNavbar ? (
                  <img
                    src={leftArrow}
                    onClick={() => setShowHideNavbar(false)}
                    alt="alt"
                    className="w-[20px] w-[20px] cursor-pointer"
                  />
                ) : (
                  <img
                    src={rightArrow}
                    onClick={() => setShowHideNavbar(true)}
                    alt="alt"
                    className="w-[20px] w-[20px] cursor-pointer"
                  />
                )}
              </>
            )}

            <h1 className="text-darkBlack font-bold text-lg">
              {title ?? t("Dashboard")}
            </h1>
          </div>

          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" }, backgroundColor: "#006AB5" }}
          >
            <MenuIcon />
          </IconButton>
          <div className="inline-flex items-center">
            <div className="flex gap-1">
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
              >
                <LanguageRounded />
              </IconButton>

              <Menu
                id="basic-menu"
                anchorEl={anchorLanguage}
                open={open}
                onClose={handleLanguageClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem onClick={() => handleLanguage("en")}>
                  English
                </MenuItem>
                <MenuItem onClick={() => handleLanguage("ce")}>
                  Chinese
                </MenuItem>
              </Menu>
              {supplier && (
                <div className="flex gap-2 items-center">
                  <img
                    src={walletIcon}
                    alt="wallet"
                    className="w-[20px] h-[20px] cursor-pointer "
                  />
                  <span className="text-dark">${amount}</span>
                </div>
              )}
            </div>
            <Typography
              variant="h6"
              noWrap
              component="div"
              className={`!ml-auto min-h-[64px] ${
                isDropdownOpen
                  ? "bg-blue ease-in duration-300 w-64 "
                  : "bg-white"
              } flex items-center justify-center`}
              aria-describedby={"simple-popover"}
              onClick={handleClickDropdown}
            >
              <div className="flex items-center justify-around w-40 cursor-pointer">
                <Avatar sizes="small" />
                <h6 className="text-black text-sm ">{`${profileData.firstName} ${profileData.lastName}`}</h6>
                {isDropdownOpen ? (
                  <DropdownWhiteIcon
                    height={10}
                    width={10}
                    fill="rgba(206, 205, 205, 0.6)"
                  />
                ) : (
                  <DropdownBlackIcon
                    height={10}
                    width={10}
                    fill="rgba(206, 205, 205, 0.6)"
                  />
                )}
              </div>
            </Typography>
            <Popover
              id={"simple-popover"}
              open={isDropdownOpen}
              anchorEl={anchorEl}
              onClose={handleCloseDropdown}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
            >
              <div className="w-64">
                <div className="flex flex-col justify-center items-center my-4">
                  <Avatar sizes="50" />
                  <h6 className="flex justify-center font-semibold text-sm mt-3">
                    {`${profileData.firstName} ${profileData.lastName}`} -{" "}
                    {`${profileData.accountType}`}
                  </h6>
                  <p className="flex justify-center text-grey-100 text-xs">
                    {t("joined at")}
                    {profileData?.date
                      ? new Date(
                          profileData?.date.seconds * 1000
                        ).toDateString()
                      : ""}
                  </p>
                </div>
                <div className="flex justify-around items-center bg-grey-200">
                  <Button
                    className="ml-0 block  bg-blue mt-4 mb-3"
                    type="submit"
                    size="small"
                    onClick={() => navigate("/profile")}
                  >
                    {t("Profile")}
                  </Button>

                  <Button
                    className="ml-0 block   bg-blue mt-4 mb-3"
                    type="submit"
                    size="small"
                    onClick={handleLogout}
                  >
                    {t("Sign Out")}
                  </Button>
                </div>
              </div>
            </Popover>
          </div>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{
          width: { sm: showHideNavbar ? drawerWidth : "0" },
          flexShrink: { sm: 0 },
        }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              backgroundColor: "#2B2A30",
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="persistent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: showHideNavbar ? drawerWidth : "0",
              backgroundColor: "#2B2A30",
            },
          }}
          open={showHideNavbar}
        >
          {drawer}
        </Drawer>
      </Box>
    </>
  );
};
export default SideBar;
